
document.addEventListener('click', function(e) {
    if (!e.target.closest('#share')) return;
    
	// It does not copy to clipboard if user clicks inside the dropdown__options (throws an errore)
	if(e.target.matches('.dropdown > a span')) {
		copyToClipboard(e.target.closest('.dropdown').querySelector('.dropdown__options a').text);
	}
});


// -------------------------------------------- Copy to clipboard
async function copyToClipboard(text) {
	try {
		await navigator.clipboard.writeText(text);
	  } catch (err) {
		console.error('Failed to copy: ', err);
	  }
}



